import { render, staticRenderFns } from "./cube_6.vue?vue&type=template&id=3e89f603&scoped=true&"
import script from "./cube_6.vue?vue&type=script&lang=js&"
export * from "./cube_6.vue?vue&type=script&lang=js&"
import style0 from "./cube_6.vue?vue&type=style&index=0&id=3e89f603&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89f603",
  null
  
)

export default component.exports